import { Injectable } from '@angular/core';
import { ExecutionResult, LcsApiService } from '@lcs/shared/api';
import { DeviceInput, PhoneInput, SipUserInput } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { HardphoneDetailSaveModel } from '../models/hardphone-detail-save.model';
import { SaveHardphone, SaveHardphoneVariables } from '../queries/generated/SaveHardphone';
import { SaveHardphoneMutation } from '../queries/save-hardphone.graphql';

@Injectable({ providedIn: 'root' })
export class AddHardphoneApiService {
   addPhoneFields: (keyof PhoneInput)[] = ['phoneId', 'phoneType', 'extensionId'];

   deviceFields: (keyof DeviceInput)[] = ['deviceId', 'phoneId'];

   devices: (keyof PhoneInput)[] = ['devices'];

   extensionId: keyof PhoneInput = 'extensionId';

   constructor(private apiService: LcsApiService) {}

   saveHardphone(hardphoneDetail: HardphoneDetailSaveModel): Observable<ExecutionResult<SaveHardphone>> {
      const fields = [
         ...this.deviceFields.map((field) => {
            return `${this.devices}.${field}`;
         }),
      ];
      if (hardphoneDetail.phoneId === 0) {
         fields.push(...this.addPhoneFields);
      }

      const devices = hardphoneDetail.devices?.map((device) => {
         this.deviceFields.reduce((acc, field) => {
            acc[field] = device[field];
            return acc;
         }, {} as DeviceInput);

         return {
            ...device,
            fields: this.deviceFields,
         };
      });


      return this.apiService.query<SaveHardphone, SaveHardphoneVariables>({
         query: SaveHardphoneMutation,
         variables: {
            phone: {
               ...hardphoneDetail,
               devices: devices,
               fields: fields,
            },
         },
      });
   }
}
